import { useMemo } from "react"
import {
  StyledEngineProvider,
  CssBaseline,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material"
import { CacheProvider } from "@emotion/react"
import GlobalStyles from "@mui/material/GlobalStyles"
import { getCacheByThemeDirection } from "utils/theme"

export const ThemeProvider = ({ theme = {}, children, ...props }) => {
  const themeDirectionCached = useMemo(
    () => getCacheByThemeDirection(theme.direction),
    [theme.direction]
  )

  return (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={themeDirectionCached}>
        <MuiThemeProvider theme={theme} {...props}>
          <CssBaseline />
          <GlobalStyles
            styles={{
              a: {
                textDecoration: "none",
              },
            }}
          />
          {children}
        </MuiThemeProvider>
      </CacheProvider>
    </StyledEngineProvider>
  )
}
